import { useEffect, useState } from "react";
import { postAxios } from "../../util/apiCall";
import axios from "axios";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import * as XLSX from "xlsx";

export const useBpb = () => {
  const dataAuth = localStorage.getItem("auth");
  const dataUser = JSON.parse(dataAuth);

  const [file, setFile] = useState(null);
  const [menu, setMenu] = useState("bpb");

  const [isCheck, setIsCheck] = useState(false);
  const [dateBpb, setDateBpb] = useState(
    moment().utcOffset("+0700").format("YYYY-MM-DD")
  );

  const [dariBagian, setDariBagian] = useState(dataUser?.bagian || "");
  const [keBagian, setKeBagian] = useState("PURCHASING");
  const [jumlah, setJumlah] = useState();
  const [produk, setProduk] = useState();

  const [keterangan, setKeterangan] = useState("");
  const [popUpTambah, setPopUpTambah] = useState(false);
  const [isBarang, setIsBarang] = useState(false);
  const [isJasa, setIsJasa] = useState(false);
  const [subMenuBpb, setSubMenuBpb] = useState("bpb");
  const [subMenu, setSubMenu] = useState("review");
  const [satuan, setSatuan] = useState();

  const [dataTempBpb, setDataTempBpb] = useState([]);

  const [popUpPick, setPopUpPick] = useState(false);
  const [dataPick, setDataPick] = useState();

  const [listBpb, setListBpb] = useState();
  const [isRefresh, setIsRefresh] = useState(false);
  const [dataHeader, setDataHeader] = useState();
  const [dataListNama, setDataListNama] = useState();
  const [errIsEmpty, setErrIsEmpty] = useState(false);

  const [filterBulan, setFilterBulan] = useState(
    moment().utcOffset("+0700").month() + 1
  );
  const [filterTahun, setFilterTahun] = useState(
    moment().utcOffset("+0700").year()
  );

  const [valueSearchBarang, setValueSearchBarang] = useState("");
  const [valueSearchJasa, setValueSearchJasa] = useState("");

  const [popUpTambahList, setPopUpTambahList] = useState(false);
  const [namaListBarangJasa, setNamaListBarangJasa] = useState("");

  const [popUpImport, setPopUpImport] = useState(false);

  const [satuanLain, setSatuanLain] = useState();

  const [filterBagian, setFilterBagian] = useState("Bagian");

  const [valueSearchItemBpb, setValueSearchItemBpb] = useState("");

  // state baru
  const [popUpCariBarang, setPopUpCariBarang] = useState(false);
  const [itemCariBpb, setItemCariBpb] = useState();
  const [listCariDataBpb, setListCariDataBpb] = useState();
  const [filterBulanDariBpb, setFilterBulanDariBpb] = useState(
    moment().utcOffset("+0700").month() + 1
  );
  const [filterTahunDariBpb, setFilterTahunDariBpb] = useState(
    moment().utcOffset("+0700").year()
  );
  const [filterBulanSampaiBpb, setFilterBulanSampaiBpb] = useState(
    moment().utcOffset("+0700").month() + 1
  );
  const [filterTahunSampaiBpb, setFilterTahunSampaiBpb] = useState(
    moment().utcOffset("+0700").year()
  );

  const constNamaBarang = dataListNama?.listNamaBarang || [];
  const constNamaJasa = dataListNama?.listNamaJasa || [];
  const mergeArray = [...constNamaBarang, ...constNamaJasa];

  useEffect(() => {
    if (itemCariBpb) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/getCariRiwayatBpb`,
        {
          tim: dataUser.tim,
          data: itemCariBpb,
          filterBulanDari: filterBulanDariBpb,
          filterTahunDari: filterTahunDariBpb,
          filterBulanSampai: filterBulanSampaiBpb,
          filterTahunSampai: filterTahunSampaiBpb,
        },
        dataUser.auth,
        setListCariDataBpb,
        ""
      );
    }
  }, [
    itemCariBpb,
    filterBulanDariBpb,
    filterTahunDariBpb,
    filterBulanSampaiBpb,
    filterTahunSampaiBpb,
  ]);

  const handleExportCariBarangBpb = async () => {
    try {
      let data = (listCariDataBpb && listCariDataBpb) || [];

      const filteredDataExcel = data.map((obj, index) => ({
        "No.": index + 1,
        "No. BPB": obj.bpbNumber,
        Tgl: moment(obj.date).utcOffset("+0700").format("DD-MM-YYYY"),
        Dari: obj.dari,
        Ke: obj.ke,
        Requestor: obj.requestor,
        Item: obj.item,
        Jumlah: obj.jumlah,
        Satuan: obj.satuan,
        Jenis: obj.jenis,
        Keterangan: obj.keterangan,
        Realisasi:
          moment(obj.realisasiDate).utcOffset("+0700").format("DD-MM-YYYY") ||
          "",
      }));

      const workSheet = XLSX.utils.json_to_sheet(filteredDataExcel);

      workSheet["!cols"] = [
        { wch: 4 },
        { wch: 10 },
        { wch: 11 },
        { wch: 15 },
        { wch: 15 },
        { wch: 22 },
        { wch: 45 },
        { wch: 9 },
        { wch: 12 },
        { wch: 10 },
        { wch: 45 },
        { wch: 10 },
        { wch: 10 },
      ];
      const workBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workBook, workSheet, "Riwayat BPB");
      XLSX.writeFile(
        workBook,
        `Riwayat BPB ${itemCariBpb.label} ${filterBulanDariBpb}-${filterTahunDariBpb} s.d ${filterBulanSampaiBpb}-${filterTahunSampaiBpb}.xlsx`
      );
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (subMenu === "review") {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/getbpb`,
        {
          tim: dataUser.tim,
          isApprove: false,
          isProccess: false,
          type: "proccess",
          filterBagian: filterBagian === "Bagian" ? "" : filterBagian,
        },
        dataUser.auth,
        setListBpb,
        ""
      );
    } else if (subMenu === "proccess") {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/getbpb`,
        {
          tim: dataUser.tim,
          isApprove: true,
          isProccess: false,
          type: "proccess",
          filterBagian: filterBagian === "Bagian" ? "" : filterBagian,
        },
        dataUser.auth,
        setListBpb,
        ""
      );
    } else if (subMenu === "done") {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/getbpb`,
        {
          tim: dataUser.tim,
          isApprove: true,
          isProccess: true,
          type: "done",
          filterDate: `${filterTahun}-${("0" + filterBulan).slice(-2)}`,
          filterBagian: filterBagian === "Bagian" ? "" : filterBagian,
        },
        dataUser.auth,
        setListBpb,
        ""
      );
    }
    let filterBulanSebelumnya = moment(
      `${filterTahun}-${("0" + filterBulan).slice(-2)}`
    )
      .add(-1, "months")
      .format("YYYY-MM");
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getbpb`,
      {
        tim: dataUser.tim,
        type: "header",
        filterDate: `${filterTahun}-${("0" + filterBulan).slice(-2)}`,
        filterBulanSebelumnya: filterBulanSebelumnya,
      },
      dataUser.auth,
      setDataHeader,
      ""
    );
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getListNamaBpb`,
      {
        tim: dataUser.tim,
      },
      dataUser.auth,
      setDataListNama,
      ""
    );

    setIsRefresh(false);
  }, [isRefresh, subMenu, filterBulan, filterTahun, filterBagian]);

  useEffect(() => {
    setFilterBagian("Bagian");
  }, [subMenu]);

  const handleKirimBpb = () => {
    if (
      dariBagian &&
      keBagian &&
      jumlah &&
      produk &&
      keterangan &&
      (isBarang || isJasa) &&
      (satuan !== "LAINNYA" ? satuan : satuanLain)
    ) {
      setDataTempBpb([
        ...dataTempBpb,
        {
          id: produk.id,
          checklistId: uuidv4(),
          isBeli: true,
          isRealisasi: false,
          item: isCheck ? produk.value : produk,
          jumlah: jumlah,
          satuan: satuan !== "LAINNYA" ? satuan : satuanLain,
          keterangan: keterangan,
          jenis: isBarang ? "Barang" : isJasa ? "Jasa" : "",
        },
      ]);

      setTimeout(() => {
        setProduk();
        setJumlah();
        setErrIsEmpty(false);
      }, 300);
    } else {
      setErrIsEmpty(true);
    }
  };

  const handlePickBpb = (data) => {
    setPopUpPick(true);
    setDataPick(data);
  };

  const handlePickJenisBpb = (e) => {
    if (e === "barang") {
      setIsJasa(false);
      setIsBarang(true);
    } else if (e === "jasa") {
      setIsJasa(true);
      setIsBarang(false);
    }
  };

  const handleDeleteBarangPick = (id) => {
    let data = [...dataTempBpb];
    data.splice(
      data.findIndex(function (i) {
        return i.id === id;
      }),
      1
    );

    setDataTempBpb(data);
  };

  const handleCloseAddBpb = () => {
    setDateBpb(moment().utcOffset("+0700").format("YYYY-MM-DD"));
    setDariBagian();
    setKeBagian();
    setIsCheck(false);
    setIsJasa(false);
    setIsBarang(false);
    setProduk();
    setPopUpTambah(false);
    setKeterangan("");
    setJumlah();
    setDataTempBpb([]);
    setSatuan();
    setSatuanLain();
  };

  const handleSubmitBpb = () => {
    if (dataTempBpb.length > 0) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/addNewBpb`,
        {
          items: dataTempBpb,
          rencana: "",
          realisasi: "",
          date: moment(dateBpb).utcOffset("+0700").format(),
          dari: dariBagian,
          ke: keBagian,
          id: uuidv4(),
          satuan: satuan,
          isApprove: false,
          isProccess: false,
          requestor: dataUser.name,
          tim: dataUser.tim,
        },
        dataUser.auth,
        "",
        ""
      );
      setTimeout(() => {
        handleCloseAddBpb();
        setIsRefresh(true);
      }, 300);
    }
  };

  const handleChangeApproval = (event, index) => {
    let data = [...dataPick.items];

    data[index][event.target.name] = event.target.value;

    setDataPick({
      ...dataPick,
      items: data,
    });
  };

  const handleApprovalBpb = () => {
    if (subMenu === "review") {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/approvalBpb`,
        {
          tim: dataUser.tim,
          data: dataPick,
          approver: dataUser.name,
          type: "finance",
          approver: dataUser.name,
        },
        dataUser.auth,
        "",
        ""
      );

      setTimeout(() => {
        setPopUpPick(false);
        setIsRefresh(true);
      }, 300);
    } else if (subMenu === "proccess" || subMenu === "done") {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/approvalBpb`,
        {
          tim: dataUser.tim,
          data: dataPick,
          approver: dataUser.name,
          type: "purchasing",
          approver: dataUser.name,
        },
        dataUser.auth,
        "",
        ""
      );
    }
    setTimeout(() => {
      setPopUpPick(false);
      setIsRefresh(true);
    }, 300);
  };

  const handleChangeChecklist = (index, event, checklistId) => {
    let data = [...dataPick.items];

    if (data[index].checklistId !== checklistId.checklistId) {
      return;
    }

    const name = event.target.name;

    if (name === "isBeli") {
      data[index][name] = event.target.checked;
    } else if (
      name === "isRealisasi" &&
      !data[index].approverProccess &&
      data[index].isBeli
    ) {
      data[index][name] = event.target.checked;
      data[index].isEditRealisasi = true;
    } else if (name === "estimasi") {
      data[index][name] = event.target.value;
      data[index].isEditEstimasi = true;
    } else if (name === "realisasiDate") {
      data[index][name] = event.target.value;
      data[index].isEditRealisasiDate = true;
    } else if (name === "catatan") {
      data[index][name] = event.target.value;
      data[index].isEditCatatan = true;
    } else if (name === "isPo" && !data[index].isPo) {
      data[index][name] = event.target.checked;
      data[index].isEditPo = true;
    } else if (name === "item") {
      data[index][name] = event.target.value;
      data[index].isEditItem = true;
    }

    setDataPick({
      ...dataPick,
      items: data,
    });
  };

  const searchFeatureBarang = (params) => {
    if (valueSearchBarang !== "") {
      let searchName = [];
      dataListNama &&
        dataListNama.listNamaBarang.forEach((value) => {
          if (
            value.value.toString().toLowerCase().includes(params.toLowerCase())
          ) {
            searchName.push(value);
          }
        });
      return searchName;
    } else {
      return dataListNama && dataListNama.listNamaBarang;
    }
  };
  let dataTempBarang = searchFeatureBarang(valueSearchBarang);

  const searchFeatureJasa = (params) => {
    if (valueSearchJasa !== "") {
      let searchName = [];
      dataListNama &&
        dataListNama.listNamaJasa.forEach((value) => {
          if (value.value.toLowerCase().includes(params.toLowerCase())) {
            searchName.push(value);
          }
        });
      return searchName;
    } else {
      return dataListNama && dataListNama.listNamaJasa;
    }
  };

  let dataTempJasa = searchFeatureJasa(valueSearchJasa);

  const handleDelete = (value, jenis) => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/addNewListBarangJasa`,
      {
        tim: dataUser.tim,
        type: "delete",
        jenis: jenis,
        value: value,
      },
      dataUser.auth,
      "",
      ""
    );

    setTimeout(() => {
      setIsRefresh(true);
    }, 300);
  };

  const handleCloseNewBarangJasa = () => {
    setIsBarang(false);
    setIsJasa(false);
    setPopUpTambahList(false);
  };

  const handleAddNewList = () => {
    if (isBarang || isJasa) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/addNewListBarangJasa`,
        {
          tim: dataUser.tim,
          type: isBarang ? "barang" : "jasa",
          value: isBarang ? `${namaListBarangJasa} ` : namaListBarangJasa,
        },
        dataUser.auth,
        "",
        ""
      );
      setTimeout(() => {
        setIsRefresh(true);
        setPopUpTambahList(false);
        setIsBarang(false);
        setIsJasa(false);
        setNamaListBarangJasa("");
      }, 300);
    }
  };

  const handleCloseImport = () => {
    setIsBarang(false);
    setIsJasa(false);
    setPopUpImport(false);
  };

  const handleBulkImportList = () => {
    if (file) {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(worksheet);

        await axios.post(
          `${process.env.REACT_APP_ENDPOINT}/addNewListBarangJasa`,
          {
            tim: dataUser.tim,
            data: json,
            type: isBarang
              ? "bulkImportBarang"
              : isJasa
              ? "bulkImportJasa"
              : "",
          },
          {
            headers: {
              Authorization: `Bearer ${dataUser.auth}`,
            },
          }
        );
      };
      reader.readAsBinaryString(file);
      setTimeout(() => {
        setIsBarang(false);
        setIsJasa(false);
        setFile(false);
        setIsRefresh(true);
        setPopUpImport(false);
        setIsRefresh(true);
      }, 300);
    }
  };

  const handleExportBulananBpb = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_ENDPOINT}/exportBulananBpb`,
        {
          tim: dataUser.tim,
          filterDate: `${filterTahun}-${("0" + filterBulan).slice(-2)}`,
        },
        {
          headers: {
            Authorization: `Bearer ${dataUser.auth}`,
          },
        }
      );

      let data = response && response.data.data;

      const filteredDataExcel = await data.map((obj, index) => {
        return {
          "No.": index + 1,
          Tgl: moment(obj.date).utcOffset("+0700").format("DD-MM-YY"),
          Jam: moment(obj.date).utcOffset("+0700").format("HH:mm:ss"),
          "No. BPB": obj.bpbNumber,
          Dari: obj.dari,
          Ke: obj.ke,
          Requestor: obj.requestor.split(" ").slice(0, 2).join(" "),
          Item: obj.item,
          Jumlah: obj.jumlah,
          Satuan: obj.satuan,
          Jenis: obj.jenis,
          Keterangan: obj.keterangan,
          isBeli: obj.isBeli,
          Estimasi: obj.estimasi ? obj.estimasi : "",
          Realisasi: obj.realisasiDate ? obj.realisasiDate : "",
          isRealisasi: obj.isRealisasi,
          catatan: obj.catatan,
        };
      });

      const workSheet = XLSX.utils.json_to_sheet(
        filteredDataExcel && filteredDataExcel
      );

      workSheet["!cols"] = [
        { wch: 4 },
        { wch: 9 },
        { wch: 9 },
        { wch: 8 },
        { wch: 20 },
        { wch: 13 },
        { wch: 22 },
        { wch: 45 },
        { wch: 9 },
        { wch: 12 },
        { wch: 10 },
        { wch: 45 },
        { wch: 8 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 27 },
      ];
      const workBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workBook, workSheet, "Barang Jadi");
      XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
      XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
      XLSX.writeFile(
        workBook,
        `Data BPB ${"0" + filterBulan} - ${filterTahun}.xlsx`
      );
    } catch (error) {
      console.log(error);
    }
  };

  const handleExportTemplate = async () => {
    try {
      const filteredDataExcel = [
        {
          nama: "",
          type: "",
          warna: "",
        },
      ];

      const workSheet = XLSX.utils.json_to_sheet(filteredDataExcel);

      workSheet["!cols"] = [{ wch: 20 }, { wch: 20 }, { wch: 20 }];
      const workBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet");
      XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
      XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
      XLSX.writeFile(workBook, `Template Import Barang Jasa.xlsx`);
    } catch (error) {
      console.log(error);
    }
  };

  const handleCancelProcess = (ele, dataPick) => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/cancelBpb`,
      {
        idRequest: dataPick.id,
        updatedBy: dataUser.name,
        dataPick: ele,
      },
      dataUser.auth,
      "",
      ""
    );
    setTimeout(() => {
      setIsRefresh(true);
      setPopUpPick(false);
    }, 300);
  };

  const handleDeleteBpb = (id) => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/deleteBpb`,
      {
        id: id,
        tim: dataUser.tim,
      },
      dataUser.auth,
      "",
      ""
    );
    setTimeout(() => {
      setIsRefresh(true);
    }, 300);
  };

  useEffect(() => {
    setFilterBagian("Bagian");
    setValueSearchItemBpb("");
  }, [subMenu]);

  const searchFeatureItemBpb = (params) => {
    if (params !== "" && listBpb) {
      return listBpb.filter(
        (data) =>
          data.items &&
          data.items.some(
            (item) =>
              item.item &&
              item.item.toString().toLowerCase().includes(params.toLowerCase())
          )
      );
    }
    return listBpb;
  };

  let dataFilterListBpb = searchFeatureItemBpb(valueSearchItemBpb);

  return {
    dataUser,
    menu,
    setMenu,
    isCheck,
    setIsCheck,
    dateBpb,
    setDateBpb,
    dariBagian,
    setDariBagian,
    keBagian,
    setKeBagian,
    jumlah,
    setJumlah,
    keterangan,
    setKeterangan,
    produk,
    setProduk,
    handleKirimBpb,
    popUpTambah,
    setPopUpTambah,
    dataTempBpb,
    handlePickBpb,
    popUpPick,
    setPopUpPick,
    dataPick,
    isBarang,
    setIsBarang,
    isJasa,
    setIsJasa,
    handleDeleteBarangPick,
    handleSubmitBpb,
    handleChangeChecklist,
    subMenu,
    setSubMenu,
    handleApprovalBpb,
    dataHeader,
    handlePickJenisBpb,
    dataListNama,
    handleCloseAddBpb,
    filterBulan,
    setFilterBulan,
    filterTahun,
    setFilterTahun,
    subMenuBpb,
    setSubMenuBpb,
    valueSearchBarang,
    setValueSearchBarang,
    dataTempBarang,
    valueSearchJasa,
    setValueSearchJasa,
    dataTempJasa,
    popUpTambahList,
    setPopUpTambahList,
    namaListBarangJasa,
    setNamaListBarangJasa,
    handleDelete,
    satuan,
    setSatuan,
    errIsEmpty,
    popUpImport,
    setPopUpImport,
    handleCloseImport,
    handleCloseNewBarangJasa,
    handleAddNewList,
    handleBulkImportList,
    setFile,
    satuanLain,
    setSatuanLain,
    filterBagian,
    setFilterBagian,
    handleExportBulananBpb,
    setIsRefresh,
    handleExportTemplate,
    handleCancelProcess,
    handleChangeApproval,
    handleDeleteBpb,
    valueSearchItemBpb,
    setValueSearchItemBpb,
    dataFilterListBpb,
    popUpCariBarang,
    setPopUpCariBarang,
    itemCariBpb,
    setItemCariBpb,
    listCariDataBpb,
    setListCariDataBpb,
    filterBulanDariBpb,
    setFilterBulanDariBpb,
    filterTahunDariBpb,
    setFilterTahunDariBpb,
    filterBulanSampaiBpb,
    setFilterBulanSampaiBpb,
    filterTahunSampaiBpb,
    setFilterTahunSampaiBpb,
    handleExportCariBarangBpb,
    mergeArray,
  };
};
